import $ from 'jquery';

$(document).ready(() => {
  
    var xmlUrl = prestashop.urls.base_url + 'rss';

    $.ajax({
        url: xmlUrl,
        type: 'GET',
        dataType: 'xml',
    }).done(function(xml) {
        //console.log(xml);
        $.each($('item', xml), function(i, e) {

            var itemId = ($(e).find('id'));

            var itemUrl = ($(e).find('link'));
            var itemImage = ($(e).find('media\\:content').attr('url'));
            var itemTitle = ($(e).find('title'));
            var itemDescription = ($(e).find('description'));
            var itemCategory = ($(e).find('category').first());

            var image = '<div class="mb-2">' +
                            '<a href="'+itemUrl.text()+'" class="text-reset">' +
                                '<img data-src="'+itemImage+'" class="img-fluid lazyload" alt="'+itemTitle.text()+'" />' +
                            '</a>' +
                        '</div>';
            var title = '<p class="h5 roboto font-weight-bold mb-2"><a href="'+itemUrl.text()+'" class="text-reset">' + itemTitle.text() + '</a></p>';
            var description = '<p class="small mb-2"><a href="'+itemUrl.text()+'" class="text-reset">' + itemDescription.text() + '</a></p>';
            var category = '<p class="super-small text-uppercase border-top border-dark">' + itemCategory.text() + '</p>';

            $(".mm_block_type_html article[id="+itemId.text()+"]").append(image + title + description + category);

        });
    });

    $('#prestablogfront .elementor-image img').on('click', function(e) {
        e.preventDefault();
        $.fancybox({
            href : $(this).parent().attr('href')
        });
    });

    $('#prestablogfront .elementor-icon-list-item > a').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var target = $(this).attr('href');
        $([document.documentElement, document.body]).animate({
            scrollTop: $(target).offset().top
        }, 500);
    });
    
});